import React from 'react';
import Select from 'react-select';

const UserFilters = ({
  filters,
  dropdowns = {},
  onFilterChange,
  onClearFilters,
  filtersToShow, // optional array override
}) => {
  const visibleFilters =
    filtersToShow || [
      'clusterId',
      'chapterId',
      'cityId',
      'stateId',
      'businessCategoryId',
      'businessSubCategoryId',
      'startDate',
      'endDate',
    ];

  const clusters = dropdowns.clusters || [];
  const chapters = dropdowns.chapters || [];
  const cities = dropdowns.cities || [];
  const states = dropdowns.states || [];
  const businessCategories = dropdowns.businessCategories || [];
  const businessSubCategories = dropdowns.businessSubCategories || [];

  const handleSingleChange = (key, selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    onFilterChange(key, value);
  };

  return (
    <div className="d-flex flex-wrap gap-3 mb-3 align-items-end border p-3 rounded shadow-sm bg-white">
      {visibleFilters.includes('clusterId') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">Cluster</label>
          <Select
            options={clusters}
            value={clusters.find((opt) => opt.value === filters.clusterId) || null}
            onChange={(selected) => handleSingleChange('clusterId', selected)}
            placeholder="Select Cluster"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('chapterId') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">Chapter</label>
          <Select
            options={chapters}
            value={chapters.find((opt) => opt.value === filters.chapterId) || null}
            onChange={(selected) => handleSingleChange('chapterId', selected)}
            placeholder="Select Chapter"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('cityId') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">City</label>
          <Select
            options={cities}
            value={cities.find((opt) => opt.value === filters.cityId) || null}
            onChange={(selected) => handleSingleChange('cityId', selected)}
            placeholder="Select City"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('stateId') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">State</label>
          <Select
            options={states}
            value={states.find((opt) => opt.value === filters.stateId) || null}
            onChange={(selected) => handleSingleChange('stateId', selected)}
            placeholder="Select State"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('businessCategoryId') && (
        <div style={{ minWidth: 220 }}>
          <label className="form-label small mb-1">Business Category</label>
          <Select
            options={businessCategories}
            value={
              businessCategories.find((opt) => opt.value === filters.businessCategoryId) || null
            }
            onChange={(selected) => handleSingleChange('businessCategoryId', selected)}
            placeholder="Select Business Category"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('businessSubCategoryId') && (
        <div style={{ minWidth: 240 }}>
          <label className="form-label small mb-1">Business Sub Category</label>
          <Select
            options={businessSubCategories}
            value={
              businessSubCategories.filter((opt) =>
                (filters.businessSubCategoryId || '').split(',').includes(opt.value)
              )
            }
            onChange={(selected) => {
              // Multi-select: selected is array
              const value = selected && selected.length
                ? selected.map(opt => opt.value).join(',')
                : '';
              onFilterChange('businessSubCategoryId', value);
            }}
            placeholder="Select Business Sub Category"
            isClearable
            isMulti
            classNamePrefix="react-select"
          />
        </div>
      )}

      {(visibleFilters.includes('startDate') || visibleFilters.includes('endDate')) && (
        <div style={{ minWidth: 280 }}>
          <label className="form-label small mb-1">Date Range</label>
          <div className="d-flex gap-2">
            {visibleFilters.includes('startDate') && (
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.startDate || ''}
                onChange={(e) => onFilterChange('startDate', e.target.value)}
                style={{ flex: 1 }}
              />
            )}
            <span className="align-self-center" style={{ fontSize: 13 }}>
              to
            </span>
            {visibleFilters.includes('endDate') && (
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.endDate || ''}
                onChange={(e) => onFilterChange('endDate', e.target.value)}
                style={{ flex: 1 }}
              />
            )}
          </div>
        </div>
      )}

      <div className="align-self-end">
        <button className="btn btn-sm btn-outline-danger mt-2" onClick={onClearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default UserFilters;